import React, { Component } from 'react';
import { Layout, Menu } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Head from './Head/index';
import styles from './Layout.module.less';
import verionSvg from '@/assets/version.svg';
import Menus from '@/routers/Menus';
import { checkMicroUrl } from '@/appRegister';
import FeedbackFloatingEntry from './component/ModifyPassModal/FeedbackFloatingEntry';

const { Sider, Content } = Layout;
const { SubMenu, Item } = Menu;

class BasicLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      prevPath: '', // 页面初次加载时路径
    };
  }

  componentDidMount() {
    const {
      location: { pathname },
    } = this.props;
    this.props.dispatch({ type: 'CHANGE_PATH', payload: [`/${pathname.split('/')[1]}`] });
    this.props.dispatch({ type: 'SELECT_PATH', payload: [`${pathname}`] });
  }

  // 浏览器前进后退改变sidebar高亮
  componentDidUpdate({ location: { pathname: prePathname } }) {
    const {
      location: { pathname },
    } = this.props;
    if (prePathname !== pathname) {
      this.props.dispatch({ type: 'SELECT_PATH', payload: [`${pathname}`] });
    }
  }

  onOpenChange = (openKeys) => {
    this.props.dispatch({ type: 'CHANGE_PATH', payload: openKeys.slice(-1) });
  };

  onSelect = ({ key }) => {
    this.props.dispatch({ type: 'CHANGE_PATH', payload: [`/${key.split('/')[1]}`] });
  };

  onCollapse = (collapsed) => {
    this.props.dispatch({ type: 'CHANGE_PATH', payload: [] });
    this.setState({ collapsed });
  };

  render() {
    const { openKeys, selectedKeys, location } = this.props;
    const { collapsed, prevPath } = this.state;
    const { children, authList, accountInfo } = this.props;
    const isHome = location.pathname === '/';
    let username = accountInfo?.accountCode || accountInfo?.userNo || '';
    username = username?.replace('sf', '');

    return checkMicroUrl(location, ['assist']) ? null : (
      <>
        <Layout className={styles.layout}>
          <Sider
            style={{
              overflow: 'auto',
              height: 'calc(100vh - 66px)',
              left: 0,
              top: 66,
              bottom: 0,
              position: 'fixed',
              zIndex: 10,
              background: '#fff',
            }}
            collapsible
            collapsed={collapsed}
            onCollapse={this.onCollapse}
          >
            {/* <div
              className={collapsed ? 'logoCollapsed logo' : 'logo'}
              onClick={() => {
                window.location.href = '/';
              }}
              role="presentation"
            /> */}
            <Menus />
            <div className="version">
              <img alt="version" className="version-icon" src={verionSvg} />
              {process.env.BUILD_VERSION}
            </div>
          </Sider>
          <Layout>
            <Head />
            <Content style={{ marginLeft: collapsed ? 80 : 200, transition: 'margin-left 0.2s' }}>
              {!!Object.keys(authList).length && children}
              <div id="ptp-container" style={{ marginTop: 66 }} />
            </Content>
          </Layout>
        </Layout>
        <FeedbackFloatingEntry username={username} />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  const { basic } = state;
  return {
    ...basic,
  };
};

export default connect(mapStateToProps)(withRouter(BasicLayout));
